var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVimeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9892 6.85317C34.8254 10.222 32.4783 14.8948 27.8385 20.763C23.0896 26.9029 19.0503 30 15.7752 30C13.7555 30 12.0088 28.1526 10.5895 24.4035C9.6616 20.9803 8.73365 17.5572 7.75111 14.1341C6.71399 10.385 5.5677 8.53756 4.36682 8.53756C4.0939 8.53756 3.16595 9.08091 1.63756 10.1676L0 8.04854C1.74673 6.52715 3.43887 5.0601 5.07643 3.53871C7.36901 1.58264 9.11575 0.495938 10.262 0.441602C12.9913 0.169926 14.6289 2.01733 15.2839 5.9838C15.9389 10.2763 16.4302 12.9387 16.7031 13.9711C17.4673 17.5029 18.3407 19.2959 19.2686 19.2959C19.9782 19.2959 21.1245 18.1549 22.5437 15.8728C24.0175 13.5907 24.7817 11.852 24.8909 10.6023C25.1092 8.5919 24.2905 7.61386 22.5437 7.61386C21.7249 7.61386 20.8516 7.8312 19.9782 8.15721C21.6704 2.56068 25.0001 -0.156086 29.8036 0.00692006C33.4608 0.00692006 35.1529 2.34334 34.9892 6.85317Z",
    fill: "#4EA27D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.9cc0ac2f.svg";
export { ForwardRef as ReactComponent };